import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-2xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                基德漫画
              </span>
            </Link>
            <p className="mt-3 text-sm text-background-50/70 leading-relaxed">
              汇聚无删减韩国漫画，下拉式免费韩漫大全在线阅读流畅，优质韩漫作品持续上新，满足阅读需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">全部漫画</Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">恋爱漫画</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">动作漫画</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">奇幻漫画</Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">剧情漫画</Link>
              </li>
              <li>
                <Link to="/category/thriller" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">悬疑漫画</Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">搞笑漫画</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">品牌介绍</Link>
              </li>
              <li>
                <a href="mailto:contact@jidemanhua.com" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 基德漫画网 - 韩国漫画无删减漫画下拉式免费韩漫大全
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-50/50">基德漫画网 - 免费韩漫大全</span>
          </div>
        </div>
      </div>
    </footer>
  );
}